import { render } from "./ConhecimentoView.vue?vue&type=template&id=409006d9&scoped=true"
import script from "./ConhecimentoView.vue?vue&type=script&lang=js"
export * from "./ConhecimentoView.vue?vue&type=script&lang=js"

import "./ConhecimentoView.vue?vue&type=style&index=0&id=409006d9&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD26\\ConfiguradorSistema\\FrontBackEndVue\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409006d9"]])

export default __exports__